import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import {
    ViewModelForm,
    withViewModelService,
} from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import React, { useCallback } from 'react';
import useAccordionStates from '../../hooks/useAccordionStates';
import useExposures from '../../hooks/useExposures';
import './ExposuresPage.messages';
import presentationMetadata from './ExposuresPage.metadata.json5';
import styles from './ExposuresStyles.module.scss';
import PersonalCyberliabilityPage from '../PersonalCyberliability/PersonalCyberliabilityPage'
import CommercialCyberliabilityPage from '../CommercialCyberliability/CommercialCyberliabilityPage'

function ExposuresPage(props) {
    const { authHeader } = useAuthentication();
    const { wizardData, updateWizardData, currentStep } = props;
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { pageKey } = currentStep;
    const metadata = presentationMetadata[pageKey];
    const { isComponentValid, initialValidation, onValidate } =
        useValidation('ExposuresPage');

    const onNext = useCallback(async () => {
        wizardData.value = await LoadSaveService.updateDraftSubmission(
            wizardData.value,
            authHeader
        );
        return wizardData;
    }, [wizardData]);




    const overrideProps = {
        personalCyberliabilityPage: {
            visible: (_.get(wizardData.value, 'lobData.cybLiaLine.selectedOffering_Ext') == 'CybLiaPer'),
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            wizardData,
            updateWizardData
        },
         commercialCyberliabilityPage: {
            visible: (_.get(wizardData.value, 'lobData.cybLiaLine.selectedOffering_Ext') == 'CybLiaCom'),
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            wizardData,
            updateWizardData
        }

    };

    
    const onSave = useCallback(
                async () => {
                    const productCode = _.get(wizardData.value, 'baseData.productCode');
                    const lobLineName = productCode ? lineName[productCode] : '';
                    const response = await updateSubmission(lobLineName, 'ExposuresPage', wizardData);
                    
                    wizardData.value = response;
                    
                    return wizardData;
                },
                [wizardData]
            );

     const resolvers = {
            resolveCallbackMap: {
                onValidate
            },
            resolveComponentMap: {
                personalCyberliabilityPage: PersonalCyberliabilityPage,
                commercialCyberliabilityPage: CommercialCyberliabilityPage
            },
            resolveClassNameMap: styles
        };

    return (
        <WizardPage
            skipWhen={() => initialValidation}
            disableNext={!isComponentValid}
            onNext={onNext}
             onSave={onSave}
        >
            <div>
                <ViewModelForm
                    uiProps={metadata.content}
                    model={wizardData}
                    onModelChange={updateWizardData}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                    overrideProps={overrideProps}
                    onValidationChange={onValidate}
                />
            </div>
        </WizardPage>
    );
}

ExposuresPage.propTypes = wizardProps;
export default withViewModelService(ExposuresPage);
